// @ts-nocheck
import type { Question } from '../types';

export const trafficLightsSignalsQuestions: Question[] = [
  {
    id: 'q-tls-1',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-1.jpg',
    topic: 'General',
    question: 'What does a red traffic light mean?',
    options: [
      { id: 'q-tls-1o1', text: 'You may proceed with caution' },
      { id: 'q-tls-1o2', text: 'You must stop and wait' },
      { id: 'q-tls-1o3', text: 'You may turn right if clear' },
    ],
    answerId: 'q-tls-1o2',
    explanation: 'A red traffic light means you must stop completely and wait. Do not proceed until the light changes to green. Red is a mandatory stop signal (RVV 1990 art. 63).',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-2',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-2.jpg',
    topic: 'General',
    question: 'What does a green traffic light mean?',
    options: [
      { id: 'q-tls-2o1', text: 'You must proceed immediately' },
      { id: 'q-tls-2o2', text: 'You may proceed if the way is clear and safe' },
      { id: 'q-tls-2o3', text: 'You must give way to pedestrians' },
    ],
    answerId: 'q-tls-2o2',
    explanation: 'A green traffic light means you may proceed, but you must still check that the way is clear and safe. You must give way to pedestrians and cyclists crossing legally. (RVV 1990 art. 62)',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-3',
    topic: 'General',
    question: 'What does an amber (yellow) traffic light mean?',
    options: [
      { id: 'q-tls-3o1', text: 'Speed up to clear the intersection' },
      { id: 'q-tls-3o2', text: 'Stop if you can do so safely; otherwise proceed with caution' },
      { id: 'q-tls-3o3', text: 'Proceed at normal speed' },
    ],
    answerId: 'q-tls-3o2',
    explanation: 'An amber (yellow) light means the signal is about to turn red. Stop if you can do so safely without braking hard. If you cannot stop safely, proceed with caution. Do not speed up to clear the intersection. (RVV 1990 art. 62)',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-4',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-4.jpg',
    topic: 'General',
    question: 'What does a green arrow traffic signal indicate?',
    options: [
      { id: 'q-tls-4o1', text: 'You may turn in the arrow direction; oncoming traffic is stopped' },
      { id: 'q-tls-4o2', text: 'You must turn in the arrow direction' },
      { id: 'q-tls-4o3', text: 'Traffic in all directions is stopped' },
    ],
    answerId: 'q-tls-4o1',
    explanation: 'A green arrow signal means you may turn in the direction of the arrow. Oncoming traffic and cross traffic are stopped, giving you protected movement. You must still check the intersection is clear before proceeding.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-5',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-5.jpg',
    topic: 'General',
    question: 'A bus at a marked bus stop on your right has its indicator on and is about to pull out into traffic. What must you do?',
    options: [
      { id: 'q-tls-5o1', text: 'Maintain your speed — you have priority on the road' },
      { id: 'q-tls-5o2', text: 'Give way to the bus — it has priority when signalling to leave a bus stop within a built-up area' },
      { id: 'q-tls-5o3', text: 'Sound your horn and proceed' },
    ],
    answerId: 'q-tls-5o2',
    explanation: 'Within a built-up area (bebouwde kom), you must give way to buses leaving a marked bus stop when they signal with an orange indicator (RVV 1990 art. 50). Slow down and allow safe departure.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-6',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-6.jpg',
    topic: 'General',
    question: 'What does a red pedestrian crossing light (red hand symbol) mean?',
    options: [
      { id: 'q-tls-6o1', text: 'Pedestrians may cross if they hurry' },
      { id: 'q-tls-6o2', text: 'Pedestrians must wait and not cross' },
      { id: 'q-tls-6o3', text: 'Pedestrians may cross but must give way to vehicles' },
    ],
    answerId: 'q-tls-6o2',
    explanation: 'A red pedestrian crossing light (red hand or "don\'t walk") means pedestrians must wait and not cross. Crossing during a red pedestrian signal is prohibited and dangerous.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-7',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-7.jpg',
    topic: 'General',
    question: 'What does a green pedestrian crossing light (green walking figure) mean?',
    options: [
      { id: 'q-tls-7o1', text: 'Pedestrians may cross but must give way to vehicles' },
      { id: 'q-tls-7o2', text: 'Pedestrians have right of way to cross safely, but must still check' },
      { id: 'q-tls-7o3', text: 'Only elderly and children may cross' },
    ],
    answerId: 'q-tls-7o2',
    explanation: 'A green pedestrian crossing light means pedestrians may cross. However, they should still check the intersection is clear and safe before crossing, particularly watching for turning vehicles.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-8',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-8.jpg',
    topic: 'General',
    question: 'You are approaching a level crossing with red lights flashing and/or barriers descending. What must you do?',
    options: [
      { id: 'q-tls-8o1', text: 'Proceed quickly — the barrier only partially blocks the crossing' },
      { id: 'q-tls-8o2', text: 'Stop immediately and do not attempt to cross' },
      { id: 'q-tls-8o3', text: 'Slow down and proceed if no train is visible' },
    ],
    answerId: 'q-tls-8o2',
    explanation: 'Red lights flashing at a level crossing indicate an approaching train. You must stop immediately and not attempt to cross. Wait for the lights to stop flashing and barriers to fully raise before crossing. (RVV 1990 art. 70)',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-9',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-9.jpg',
    topic: 'General',
    question: 'At a level crossing, what does a steady amber light (without flashing) indicate?',
    options: [
      { id: 'q-tls-9o1', text: 'A train has just passed; you may now cross' },
      { id: 'q-tls-9o2', text: 'The crossing is about to be activated; prepare to stop' },
      { id: 'q-tls-9o3', text: 'You must cross immediately' },
    ],
    answerId: 'q-tls-9o2',
    explanation: 'A steady amber light at a level crossing indicates the crossing is about to be activated. Reduce speed and prepare to stop, as red lights and barriers will activate shortly. (RVV 1990 art. 70)',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-10',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-10.jpg',
    topic: 'General',
    question: 'What does an orange indicator light on a vehicle ahead indicate?',
    options: [
      { id: 'q-tls-10o1', text: 'The vehicle is about to brake' },
      { id: 'q-tls-10o2', text: 'The vehicle is signalling its intention to turn or change lane' },
      { id: 'q-tls-10o3', text: 'The vehicle has a mechanical fault' },
    ],
    answerId: 'q-tls-10o2',
    explanation: 'An orange indicator light (also called a turn signal or blinker) shows the driver\'s intention to turn or change lane. You should anticipate this manoeuvre and adjust your driving accordingly.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-11',
    topic: 'General',
    question: 'What must you do when an emergency vehicle with blue flashing lights and siren is approaching?',
    options: [
      { id: 'q-tls-11o1', text: 'Maintain your speed and stay in your lane' },
      { id: 'q-tls-11o2', text: 'Give way immediately by moving aside where safe' },
      { id: 'q-tls-11o3', text: 'Sound your horn to alert other drivers' },
    ],
    answerId: 'q-tls-11o2',
    explanation: 'Emergency vehicles (police, ambulance, fire) with blue flashing lights have absolute priority (RVV 1990 art. 91). You must give way immediately by moving aside where safe, without endangering others.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-12',
    topic: 'General',
    question: 'What do red tail lights on a vehicle ahead indicate?',
    options: [
      { id: 'q-tls-12o1', text: 'The vehicle is turning right' },
      { id: 'q-tls-12o2', text: 'The vehicle is reversing or has brake lights illuminated' },
      { id: 'q-tls-12o3', text: 'The vehicle is a taxi' },
    ],
    answerId: 'q-tls-12o2',
    explanation: 'Red tail lights indicate the vehicle\'s brake lights are on (braking) or it is reversing. Always increase your distance when you see brake lights to avoid collision.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-13',
    topic: 'General',
    question: 'What does a white reversing light indicate?',
    options: [
      { id: 'q-tls-13o1', text: 'The vehicle is malfunctioning' },
      { id: 'q-tls-13o2', text: 'The vehicle is reversing or about to reverse' },
      { id: 'q-tls-13o3', text: 'The vehicle is being towed' },
    ],
    answerId: 'q-tls-13o2',
    explanation: 'White reversing lights illuminate when a vehicle is reversing or about to reverse. Be alert to vehicles backing up, especially in car parks and residential areas.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-14',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-14.jpg',
    topic: 'General',
    question: 'What does a flashing amber light on a traffic signal mean?',
    options: [
      { id: 'q-tls-14o1', text: 'The signal is broken; you may proceed at your discretion' },
      { id: 'q-tls-14o2', text: 'You must proceed cautiously as priority to the right applies' },
      { id: 'q-tls-14o3', text: 'Stop and wait for a green light' },
    ],
    answerId: 'q-tls-14o2',
    explanation: 'A flashing amber light means the traffic signal is not fully operational. Treat the intersection like an unmarked junction where priority to the right applies. Proceed cautiously and be prepared to give way.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-15',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-15.jpg',
    topic: 'General',
    question: 'What does a red X symbol on an overhead motorway signal indicate?',
    options: [
      { id: 'q-tls-15o1', text: 'That lane is closed and must not be used' },
      { id: 'q-tls-15o2', text: 'Speed limit for that lane only' },
      { id: 'q-tls-15o3', text: 'Parking is forbidden in that lane' },
    ],
    answerId: 'q-tls-15o1',
    explanation: 'A red X symbol on an overhead motorway signal indicates that lane is closed. Do not enter that lane or you risk collision with other vehicles or stationary obstacles.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-16',
    topic: 'General',
    question: 'What does a green arrow with a horizontal line through it on a traffic signal indicate?',
    options: [
      { id: 'q-tls-16o1', text: 'The turn is compulsory' },
      { id: 'q-tls-16o2', text: 'The turn is no longer compulsory; general traffic light rules now apply' },
      { id: 'q-tls-16o3', text: 'Turning is prohibited' },
    ],
    answerId: 'q-tls-16o2',
    explanation: 'A green arrow with a line through it (or arrow turning off) indicates the protected turn phase is ending. General traffic light rules now apply; you must give way to opposing traffic if turning.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-17',
    topic: 'General',
    question: 'You are at a traffic light and the green arrow allows you to turn. There is a cyclist on the cycle path crossing your path. What must you do?',
    options: [
      { id: 'q-tls-17o1', text: 'Proceed — the green arrow protects you completely' },
      { id: 'q-tls-17o2', text: 'Give way to the cyclist even with a green arrow' },
      { id: 'q-tls-17o3', text: 'Sound your horn and proceed' },
    ],
    answerId: 'q-tls-17o2',
    explanation: 'Even with a green arrow, you must give way to cyclists on a cycle path (fietspad) crossing your turning path. A green arrow protects you from opposing traffic, not from vulnerable road users.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-18',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-18.jpg',
    topic: 'General',
    question: 'What does amber flashing lights on a roadside or barrier indicate?',
    options: [
      { id: 'q-tls-18o1', text: 'Danger ahead; reduce speed immediately' },
      { id: 'q-tls-18o2', text: 'A temporary hazard or roadworks; proceed with caution' },
      { id: 'q-tls-18o3', text: 'You must stop before proceeding' },
    ],
    answerId: 'q-tls-18o2',
    explanation: 'Amber flashing lights on roadside equipment or barriers warn of temporary hazards, roadworks, or emergency situations. Reduce speed and proceed with extra caution, being prepared to stop.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-19',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/traffic-lights/q-tls-19.jpg',
    topic: 'General',
    question: 'At a traffic light intersection, you have a green light but see pedestrians still crossing. What must you do?',
    options: [
      { id: 'q-tls-19o1', text: 'Proceed — you have right of way with a green light' },
      { id: 'q-tls-19o2', text: 'Stop and give way to the pedestrians' },
      { id: 'q-tls-19o3', text: 'Sound your horn to alert pedestrians' },
    ],
    answerId: 'q-tls-19o2',
    explanation: 'You must always give way to pedestrians legally crossing, even if your light is green. Pedestrians who started crossing on a "walk" signal have right of way to complete their crossing safely.',
    subject: 'Traffic Lights & Signals',
  },
  {
    id: 'q-tls-20',
    topic: 'General',
    question: 'What is the purpose of traffic light signals in traffic control?',
    options: [
      { id: 'q-tls-20o1', text: 'To allow drivers to proceed freely without concern for other traffic' },
      { id: 'q-tls-20o2', text: 'To regulate traffic flow, assign right-of-way, and manage safe movement at intersections' },
      { id: 'q-tls-20o3', text: 'To penalize drivers who break the rules' },
    ],
    answerId: 'q-tls-20o2',
    explanation: 'Traffic lights regulate traffic flow by controlling when vehicles and pedestrians move, preventing conflicts and managing safe intersections. All road users must obey traffic signals (RVV 1990).',
    subject: 'Traffic Lights & Signals',
  },
];
